import { memo } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import type { CenteredLayoutProps } from "./types";

const Centered = ({ children, slotProps, ...restProps }: CenteredLayoutProps) => (
    <Container
        component='main'
        maxWidth='xs'
        {...restProps}
    >
        <Box
            {...slotProps?.container}
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ...slotProps?.container?.sx,
            }}
        >
            {children}
        </Box>
    </Container>
);

export default memo(Centered);
